import { Flex } from "@chakra-ui/react";
import KelpStatsCard from "./KelpStatsCard";
import useDappChain from "@hooks/useDappChain";
import AssetsRestakedCard from "./AssetsRestakedCard";
import GainOpportunities from "./GainOpportunies";

const RightSidebar = () => {
  const { isEthereumChain } = useDappChain();

  return (
    <Flex
      pos={{ base: "initial", xl: "sticky" }}
      top={{ base: "initial", xl: 140 }}
      p={4}
      pt={{ base: 4, xl: 0 }}
      gap={4}
      direction="column"
      maxW={{ base: "100%", md: 680, xl: 280 }}
      w={{ base: "100vw", md: 680, xl: 280 }}
    >
      <KelpStatsCard />
      <GainOpportunities />
      {isEthereumChain && <AssetsRestakedCard />}
    </Flex>
  );
};

export default RightSidebar;
